import React, { useState, useEffect, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Card, CardHeader, CardContent, TextField, Grid, Button, Autocomplete } from '@mui/material';

import { enqueueSnackbar } from 'actions';

import DataTableScripting from './components/DataTableScripting';

import { GetScripts } from '../../actions/ScriptingActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	paper: {
		padding: theme.spacing(1),
	},
	popover: {
		pointerEvents: 'none',
	},
}));

const Scripting = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const scripts = useSelector(state => state.scriptingReducer.scripts);

	const _getScripts = useCallback(() => {
		dispatch(GetScripts());
	}, []);

	useEffect(() => {
		_getScripts();
	}, [_getScripts]);

	return (
		<div className={clsx(classes.container)}>
			<DataTableScripting className={classes.container} data={scripts} />
		</div>
	);
};

export default Scripting;
